import { LangService } from "../../common/api.service"

export default {
  namespaced: true,
  state: {
    language: [],
  },
  mutations: {
    setLanguage(state, payload) {
      state.language = payload.languages;
    },
  },
  actions: {
    async  fetchLanguage({ commit }, locale) {
      return await LangService.get(locale)
      .then(({ data }) => {
        commit('setLanguage', data)
        commit('setLocale', data.locale, { root: true })
        return data
      })
      .catch((reason) => {
        console.log(reason.message)
        })
      },
  },
  getters: {
    getLanguage: state => {
      return state.language
    },
  }
}